export enum AssessmentStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Completed = 'completed',
  PendingScoring = 'pendingScoring',
  UnRead = 'unRead',
  SeenOn = 'seenOn'
}
